import { render, staticRenderFns } from "./SKPTriwulan.vue?vue&type=template&id=520c5b8b&scoped=true&lang=html&"
import script from "./SKPTriwulan.vue?vue&type=script&lang=js&"
export * from "./SKPTriwulan.vue?vue&type=script&lang=js&"
import style0 from "./SKPTriwulan.vue?vue&type=style&index=0&id=520c5b8b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c5b8b",
  null
  
)

export default component.exports